import { IProduct } from '../../ProductList/models/response/getProductListResponseModel'

export enum IBannerTypeEnum {
  LinkYok = 1,
  UruneLink = 2,
  ListeEkrani = 3,
  AyniPencereLink = 4,
  ÜrünAltTip = 5,
  YeniPencereLink = 6,
  YoutubeVideo = 7,
  VimeoVideo = 8,
  Video = 9,
}
export enum ILocationEnum {
  Login = 1,
  AnaSayfaSolUst = 2,
  AnaSayfaSolAlt = 3,
  AnaSayfaSag = 4,
  SayacAnaSayfaUst = 5,
  SayacAnaSayfaAlt = 6,
  BanaOzel = 7,
  Modal = 8,
  OrtaBanner = 9,
  AltBanner = 10,
}
export enum ICounterLocationEnum {
  Slider = 1,
  AltAlta = 2,
}

export interface IBanner {
  Id: number
  Title: string
  Description: string
  Location: ILocationEnum
  CompanyList: number[]
  Category: 0
  Order: 0
  Link: string
  Active: boolean
  StartDate: Date
  EndDate: Date
  CariTypeCode: []
  CariSubTypeCode: []
  Image: string
  ImageUrl: string
  MobilImage: string
  CounterLocation: ICounterLocationEnum
  DontShowToUsers: string
  ProductCode: []
  ProductAddress: string
  BannerType: IBannerTypeEnum
  VideoId: string
  IsHomepage: boolean
  IsGiniIntro: boolean
}
export interface IBrandList {
  Id: number
  Image: string
  ImageUrl: string
  Name: string
  Companies: []
}

export interface IBrandDetail {
  List: IBrandList[]
  Count: number
}

export interface IHomepageProducts {
  Id: number
  Name: string
  Image: string
  SapCode: string
}

export interface IProductList {
  MostFavourites: IProducts
  NewProducts: IProducts
  OpportunitMarket: IProducts
  PromotionalProducts: IProducts
  RecentVisits: IProducts
  Suggestion: IProducts
}

export interface IProducts {
  Count: number
  Products: IProduct[]
}

export interface ICampaignsProducts {
  PageSize: number
  PageNumber: number
  CampaignId: number
  Company: number
}

export interface IBestSellers {
  CategoryName: string
  Product: IProduct
}

export interface IProductSuggestionAI {
  Count: number
  Products: IProduct[]
  ProductsCount: number
}

/** Excel ile yüklenen bayi bazlı duyuru popup'ı. */
export interface IExcelAnnouncementPopupItem {
  RowId: number
  Topic: string
  Description: string
}

/** Popup altında listelenen teminat mektubu. Alanlar teminat sayfasıyla aynı. */
export interface IExcelAnnouncementGuaranteeLetter {
  No: string
  StartDate: string
  EndDate: string
  Bank: string
  TaxLocation: string
  Amount: number
  /** 0 normal (yeşil), 1 yakında biter (turuncu), 2 vadesi geçmiş (kırmızı) */
  Status: number
}

export interface IExcelAnnouncementPopup {
  Id: number
  /** 1 = her satır ayrı popup, 2 = tek popup içinde alt alta */
  GroupMode: number
  /** 1 = resim açıklamanın üstünde, 2 = altında */
  ImagePosition: number
  Image?: string
  ImageUrl?: string
  Items: IExcelAnnouncementPopupItem[]
  /** Yalnız "teminat duyurusu" işaretliyse dolu gelir; boşsa bölüm hiç çizilmez. */
  GuaranteeLetters?: IExcelAnnouncementGuaranteeLetter[]
  GuaranteeTotal?: number
}
